var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiSrBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-badge",
    clipPath: "url(#clip0_11167_18434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 16.5C10.4178 16.5 8.87103 16.0308 7.55544 15.1517C6.23985 14.2727 5.21447 13.0233 4.60897 11.5615C4.00347 10.0997 3.84504 8.49112 4.15372 6.93927C4.4624 5.38743 5.22433 3.96197 6.34315 2.84315C7.46197 1.72433 8.88743 0.962403 10.4393 0.653721C11.9911 0.34504 13.5997 0.503466 15.0615 1.10897C16.5233 1.71447 17.7727 2.73985 18.6518 4.05544C19.5308 5.37103 20 6.91775 20 8.49999C19.9976 10.621 19.154 12.6544 17.6542 14.1542C16.1545 15.654 14.121 16.4976 12 16.5ZM12 18.5C9.83339 18.499 7.72645 17.79 6 16.481V22C6 22.4709 6.13301 22.9323 6.38374 23.331C6.63446 23.7296 6.99269 24.0494 7.41717 24.2533C7.84164 24.4573 8.31511 24.5373 8.78303 24.4839C9.25095 24.4306 9.69429 24.2462 10.062 23.952L11.688 22.652C11.7766 22.5812 11.8866 22.5427 12 22.5427C12.1134 22.5427 12.2234 22.5812 12.312 22.652L13.938 23.952C14.3057 24.2462 14.7491 24.4306 15.217 24.4839C15.6849 24.5373 16.1584 24.4573 16.5828 24.2533C17.0073 24.0494 17.3656 23.7296 17.6163 23.331C17.867 22.9323 18 22.4709 18 22V16.481C16.2735 17.7899 14.1666 18.4989 12 18.5Z",
    fill: "#118AB2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11167_18434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrBadge);
export default __webpack_public_path__ + "static/media/fi-sr-badge.876762f55ccb41df82b56116a019e971.svg";
export { ForwardRef as ReactComponent };